import { IShipmentListItem, ShipmentLastStatusMessageUpdateResponse } from '@typings/shipment';
import angular from 'angular';
import { angularScopeApply } from '@/utils/angular';
import { notifyShipmentUpdateListeners } from '@/features/PusherEventShipment/store';
import { LabelStatus } from '@/constants/shipments';
import { hasLabelStatusDocumentsGenerated, hasLabelStatusFailed } from '@/utils/shipment';
import { updateJobLabelStateOnQueue } from '@/features/PrintingDocuments/store';

const onShipmentStatusUpdate = (data: ShipmentLastStatusMessageUpdateResponse) => {
  const service: {
    mutateVisibleShipment: (shipmentId: string, shipment: IShipmentListItem) => void;
    getShipmentById: (shipmentId: string) => IShipmentListItem | undefined;
    currentShipments: IShipmentListItem[] | null;
  } = angular.element(document.body).injector().get('ShipmentListManageService');

  if (!service || !data.shipment?.id) return;

  notifyShipmentUpdateListeners(data.shipment);

  if (data.shipment?.label_state)
    updateJobLabelStateOnQueue(data.shipment.id, data.shipment.label_state as LabelStatus);
  const isShipmentVisibleOnThePage = service.currentShipments?.some(
    (shipment) => shipment.id === data.shipment?.id
  );
  if (!isShipmentVisibleOnThePage) return;

  const prevShipment = service.getShipmentById(data.shipment?.id);
  if (!prevShipment) return;
  service.mutateVisibleShipment(data.shipment.id, {
    ...prevShipment,
    ...data.shipment,
  });
  angularScopeApply();
};

export const useShipmentStatusUpdateEvent = () => {
  return onShipmentStatusUpdate;
};

export const updateShipmentFromFetch = (shipment: IShipmentListItem) => {
  const status = shipment.label_state as LabelStatus;
  if (hasLabelStatusFailed(status) || hasLabelStatusDocumentsGenerated(status))
    onShipmentStatusUpdate({ shipment });
};
